import React from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";

const Cancel = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4, textAlign: "center" }}>
        <CancelIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
        
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Payment Cancelled
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          No worries — your payment was not processed and you have not been charged.
        </Typography>

        <Button
          variant="contained"
          size="large"
          fullWidth
          href="/"
        >
          Try Again
        </Button>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          Have questions? Contact us at{" "}
          <a href="mailto:support@secondclear.com">support@secondclear.com</a>
        </Typography>
      </Paper>
    </Container>
  );
};

export default Cancel;
